export const isRequiredMessage = 'is required';
export const dateIsRequiredMessage = `date ${isRequiredMessage}`;
export const mustBeBetween0And100Message = 'must be between 0 and 100';
